import { useState } from 'react'
import { getSortDescription } from '/src/models/concerns/inspection'

export default function useSorting(sort, onChange) {
  const [sorting, setSorting] = useState(sort)

  const onSortChange = (event, gridColumns) => {
    if (onChange) onChange()
    const newSort = []
    event.sort.forEach((sortColumn) => {
      const realSort = getSortDescription(sortColumn, gridColumns)
      newSort.push({ ...sortColumn, realSort })
    })
    setSorting(() => newSort)
  }
  return { sorting, onSortChange }
}
